import UpvoteButton from './UpvoteButton';
export default UpvoteButton;
